import { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_PATH } from "../../environment";

const PROJECT_BASE_URL = API_BASE_PATH;

export interface ProjectBoard {
  project_id: string;
  project_name: string;
  team_members: string[]; // assuming this is a list of image URLs or names
  total_hours: number;
  deadline: string;
  priority: "High" | "Medium" | "Low";
}

export function useProjectBoard() {
  const [data, setData] = useState<ProjectBoard[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchProjectBoard = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${PROJECT_BASE_URL}/Admindashboard/projects-summary`
      );

      const transformed = (response.data || []).map((project: any) => ({
        ...project,
        team_members: project.team_members[0]
          ? project.team_members[0].split(",")
          : [],
      }));
      setData(transformed);
    } catch (err: any) {
      setError(err.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProjectBoard();
  }, []);

  return { data, isLoading, error, refetch: fetchProjectBoard };
}
